import moment, { MomentInput } from 'moment';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { changeJourneyParam } from '@store/yourJourney/actions';

export function useSyncSpaDateToRedux(
  formDate: string | undefined,
  reduxSpaDate: MomentInput | undefined
) {
  const dispatch = useDispatch();
  const syncedFormDate = useRef<string>();

  useEffect(() => {
    if (!formDate || formDate === syncedFormDate.current) return;
    syncedFormDate.current = formDate;
    const reduxDateString = reduxSpaDate ? moment(reduxSpaDate).format('YYYY-MM-DD') : '';
    if (formDate !== reduxDateString) {
      dispatch(changeJourneyParam('spaDate', formDate) as any);
    }
  }, [formDate, reduxSpaDate, dispatch]);
}
